import { render, staticRenderFns } from "./storeDangerPermitDetail.vue?vue&type=template&id=04b4e46a"
import script from "./storeDangerPermitDetail.vue?vue&type=script&lang=js"
export * from "./storeDangerPermitDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04b4e46a')) {
      api.createRecord('04b4e46a', component.options)
    } else {
      api.reload('04b4e46a', component.options)
    }
    module.hot.accept("./storeDangerPermitDetail.vue?vue&type=template&id=04b4e46a", function () {
      api.rerender('04b4e46a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chm/dangerPermit/storeDangerPermitDetail.vue"
export default component.exports